import { z } from 'zod'

import { EmptyArraySchema } from 'shared/api/common/schemas/base'

export const GoogleSheetSchemas = {
  getLists: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      spreadsheets: z
        .array(z.object({ id: z.string(), name: z.string(), link: z.string() }))
        .or(EmptyArraySchema),
    }),
  },
  getWorksheets: {
    path: z.undefined(),
    query: z.object({ spreadsheet_id: z.string() }),
    request: z.undefined(),
    response: z.object({
      sheets: z.array(z.object({ title: z.string(), link: z.string() })).or(EmptyArraySchema),
    }),
  },
  getColumnHeaders: {
    path: z.undefined(),
    query: z.object({ spreadsheet_id: z.string(), sheet_title: z.string().nullable() }),
    request: z.undefined(),
    response: z.object({
      column_headers: z
        .array(z.object({ key: z.string(), header: z.string() }))
        .or(EmptyArraySchema),
    }),
  },
}
